import React from 'react';
import { Modal, useModalVariant } from '@chargify/custom-ui-components';
import { useSelector } from '@xstate/react';
import { useComponentSettings, useServices } from '../../hooks';
import { modalsSelectors } from '../../machines';
import { Content } from './components';
import { useCancelAvailableOptions } from './hooks';

const CancelSubscription = () => {
  const { modalsService } = useServices();
  const { subscription } = useComponentSettings();
  const modalVariant = useModalVariant();
  const { isOpen, meta } = useSelector(
    modalsService,
    modalsSelectors.getCancelSubscription
  );
  const availableCancelOptions = useCancelAvailableOptions(subscription.scopes);
  const closeHandler = () => modalsService.send({ type: 'CLOSE_MODAL' });
  return (
    <Modal
      isOpen={isOpen}
      onClose={closeHandler}
      variant={modalVariant}
      width="100%"
    >
      <Content
        {...meta}
        enabledChurnReasonCodes={subscription.churnReasonCodes}
        displayMode={modalVariant}
        onClose={closeHandler}
        availableCancelOptions={availableCancelOptions}
      />
    </Modal>
  );
};

export default CancelSubscription;
